export default "__VITE_ASSET__BdAeTwct__"